export default __webpack_public_path__ + "static/media/4.6d82af7e.png";